import { sectionContainerAtom } from '@ingenico/react-section-utils';
import deepEqual from 'fast-deep-equal';
import { createStore, Provider } from 'jotai';
import type { ReactElement } from 'react';
import { memo, useMemo } from 'react';
import { deviceManagementContainer } from '../../container.const';
import { LogicalDeviceConfigurationTab } from '../logical-device-configuration-tab/LogicalDeviceConfigurationTab.ctrl';
import { useLogicalDeviceConfigurationSelection } from './useLogicalDeviceConfigurationSelection.hook';

function ExposedLogicalDeviceConfigurationTabCpnt(): ReactElement {
  const store = useMemo(() => {
    const sectionStore = createStore();
    sectionStore.set(sectionContainerAtom, deviceManagementContainer);
    return sectionStore;
  }, []);

  const { category: selectedCategory, applicationId: selectedApplicationId } = useLogicalDeviceConfigurationSelection();

  return (
    <Provider store={store}>
      <LogicalDeviceConfigurationTab
        selectedApplicationId={selectedApplicationId}
        selectedCategory={selectedCategory}
      />
    </Provider>
  );
}

export const ExposedLogicalDeviceConfigurationTab = memo(ExposedLogicalDeviceConfigurationTabCpnt, deepEqual);
